<router-outlet></router-outlet> 
<ngx-spinner type="line-spin-clockwise-fade"></ngx-spinner>